import { computed } from 'vue';

export const useCustomVendorStore = defineStore('vendor', () => {
    const { apiClient } = useShopwareContext(); // Access Shopware API client

    const pendingRequests = new Map<string, Promise<void>>();
    const vendors = ref(new Map<string, object>());

    const loading = computed(() => {
        return pendingRequests.size > 0;
    });

    const fetchVendorsByIds = async (vendorIds: string[]) => {
        vendorIds.forEach(vendorId => {
            if (
                vendorId &&
                vendorId !== 'undefined' &&
                !pendingRequests.has(vendorId) &&
                !vendors.value.has(vendorId)
            ) {
                const pendingRequest = (async () => {
                    try {
                        const { data } = await apiClient.invoke(`searchVendors post /vendor/search`, {
                            body: {
                                ids: vendorId,
                                page: 1,
                                associations: {
                                    products: {
                                        limit: 1,
                                        "total-count-mode": 1
                                    },
                                    shippingMethod: {
                                        "total-count-mode": 1,
                                        associations: {
                                            prices: {
                                                "total-count-mode": 1
                                            }
                                        }
                                    },
                                },
                                "total-count-mode": 1
                            },
                        });
                        vendors.value.set(vendorId, data);
                    } catch (err) {
                        console.error('Vendor information missing');
                        pendingRequests.delete(vendorId);
                    } finally {
                        pendingRequests.delete(vendorId);
                    }
                })();
                pendingRequests.set(vendorId, pendingRequest);
            }
        });

        await Promise.all([...pendingRequests.values()]);

        if (!vendors.value.size) return [];

        return [...vendors.value.values()].filter(vendor => {
            return vendorIds.includes(vendor.id);
        });
    };

    const getVendorById = async vendorId => {
        if (!vendors.value.has(vendorId)) {
            await fetchVendorsByIds([vendorId]);
        }

        return vendors.value.get(vendorId);
    };

    return {
        fetchVendorsByIds,
        getVendorById,
        vendors,
        loading,
    };
});
